import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearachCustomerComponent } from './searach-customer/searach-customer.component';
import { MastersModule } from '../masters/masters.module';
import { PipesModule } from '../../Pipes/pipes.module';
import { ServiceModule } from '../../Services/service.module';
import { SpraRequestComponent } from './spra-request/spra-request.component';
import { CustomerRankUploadComponent } from './customer-rank-upload/customer-rank-upload.component';
import { ProductPriceUploadComponent } from './product-price-upload/product-price-upload.component';
import { UploadCsaRateComponent } from './upload-csa-rate/upload-csa-rate.component';
import { SpraRequestListComponent } from './spra-request-list/spra-request-list.component';
import { SpraViewDataComponent } from './spra-view-data/spra-view-data.component';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';
import { SpraServiceComponent } from './spra-service/spra-service.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';import { SpraValidationlistComponent } from './spra-validationlist/spra-validationlist.component';
import { SpraAdminsalesvalidateListComponent } from './spra-adminsalesvalidate-list/spra-adminsalesvalidate-list.component';
import { SpraOpenddenquiryListComponent } from './spra-openddenquiry-list/spra-openddenquiry-list.component';
import { SpraViewOpsComponent } from './spra-view-ops/spra-view-ops.component';
import { SpraRentalRequestComponent } from './spra-rental-request/spra-rental-request.component';
import { UploadConsumableTargetComponent } from './upload-consumable-target/upload-consumable-target.component';
import { SpraStatusReportComponent } from './spra-status-report/spra-status-report.component';
import { SpraValidationComponent } from './spra-validation/spra-validation.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SpraSalesadminreviewListComponent } from './spra-salesadminreview-list/spra-salesadminreview-list.component';
import { SpraSalesadminapprevListComponent } from './spra-salesadminapprev-list/spra-salesadminapprev-list.component';
@NgModule({
  declarations: [SearachCustomerComponent, 
    SpraRequestComponent,
    CustomerRankUploadComponent, 
    ProductPriceUploadComponent, 
    UploadCsaRateComponent, 
    SpraRequestListComponent,  
    SpraViewDataComponent, 
    SpraServiceComponent,
    SpraValidationlistComponent,
    SpraAdminsalesvalidateListComponent,
    SpraOpenddenquiryListComponent,
    SpraViewOpsComponent,
    SpraRentalRequestComponent,
    UploadConsumableTargetComponent,
    SpraStatusReportComponent,
    SpraValidationComponent,
    DashboardComponent,
    SpraSalesadminreviewListComponent,
    SpraSalesadminapprevListComponent],

  imports: [
    CommonModule,
    FormsModule,
    MastersModule.forRoot(),    
    ServiceModule.forRoot(),
    PipesModule.forRoot(),  
    MatCardModule,
    MatDividerModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule
  ]
})
export class SpraModule {
  static forRoot(): ModuleWithProviders<SpraModule> {
    return {
      ngModule: SpraModule
    }
  }

 }
